export function debounce(func: Function) {
  let timer: number;
  return function (event: Event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}
